export default __webpack_public_path__ + "static/media/Twitter.942c0e43.svg";